import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { finalize, Subscription } from 'rxjs';
import { DealersService } from '../../dealers.service';
import { DealerInsights, OrderHistory } from '../../dealers.model';
import { TabItem } from '../../../common/models/common.model';

@Component({
  selector: 'app-dealer-details',
  standalone: false,
  templateUrl: './dealer-details.component.html',
  styleUrl: './dealer-details.component.scss',
})
export class DealerDetailsComponent implements OnInit, OnDestroy {
  protected isDataLoading: boolean = false;
  protected isExportingOrders: boolean = false;
  protected isExportingPayments: boolean = false;
  protected dealerId!: string;
  protected insights?: DealerInsights;

  protected selectedTab: string = 'orders';
  protected tabs: TabItem[] = [
    { label: 'Orders History', icon: 'bi bi-box-seam', value: 'orders' },
    { label: 'Payments History', icon: 'bi bi-credit-card', value: 'payments' },
  ];

  private _subscription: Subscription = new Subscription();

  constructor(
    private route: ActivatedRoute,
    private dealersService: DealersService
  ) {}

  ngOnInit(): void {
    this.dealerId = this.route.snapshot.params['id'];
    this._getDealerInsights();
  }

  private _getDealerInsights(): void {
    this.isDataLoading = true;
    const sub = this.dealersService
      .insights(this.dealerId)
      .pipe(finalize(() => (this.isDataLoading = false)))
      .subscribe({
        next: (res: DealerInsights) => {
          this.insights = res;
        },
        error: err => {
          console.error('Error fetching dealer insights', err);
        },
      });
    this._subscription.add(sub);
  }

  protected onExportOrders(): void {
    this.isExportingOrders = true;

    const sub = this.dealersService
      .exportOrders(this.dealerId)
      .pipe(finalize(() => (this.isExportingOrders = false)))
      .subscribe({
        next: (blob: Blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `dealer_${this.dealerId}_orders.xlsx`;
          a.click();
          URL.revokeObjectURL(url);
        },
      });

    this._subscription.add(sub);
  }

  protected onExportPayments(): void {
    this.isExportingPayments = true;

    const sub = this.dealersService
      .exportPayments(this.dealerId)
      .pipe(finalize(() => (this.isExportingPayments = false)))
      .subscribe({
        next: (blob: Blob) => {
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `dealer_${this.dealerId}_payments.xlsx`;
          a.click();
          URL.revokeObjectURL(url);
        },
      });

    this._subscription.add(sub);
  }

  protected selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  protected getStatusBadgeClass(status: string): string {
    switch (status.toLowerCase()) {
      case 'cancelled':
        return 'bg-danger';
      case 'delivered':
        return 'bg-success';
      case 'shipped':
        return 'bg-primary';
      default:
        return 'bg-warning text-dark';
    }
  }

  protected viewProof(url: string | null): void {
    if (url) {
      window.open(url, '_blank');
    }
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
